import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=754ff670&scoped=true"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"
import style0 from "./configure.vue?vue&type=style&index=0&id=754ff670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ff670",
  null
  
)

export default component.exports